import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Select, Tab } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import CaptureButtons from './CaptureButtons';
import { Activity } from '../../../app/models/activity';
import QrCodeScannerModal from '../../../app/common/modals/QrCode/QrCodeScannerModal';
import BarCodeScannerModal from '../../../app/common/modals/BarCode/BarCodeScannerModal';
import RfidScannerModal from '../../../app/common/modals/Rfid/RfidScannerModal';
import { optionsInterface } from '../../../app/models/tabverify';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import agent from '../../../app/api/agent';
import { toast } from 'react-toastify';
import LoadingComponent from './../../../app/layout/LoadingComponent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { v4 as uuid } from 'uuid';
import { PDFDownloadLink } from '@react-pdf/renderer';
import TagVerifyPDF from './TagVerifyPDF';
import { uploadFileType } from '../../../app/api/types';
import { assetConditionOptions } from './DashboardTagContainer';

function DashboardOnClickedTag() {
  const {
    dashboardStore: { dashboard, tagCount, getLocalFilesBasedOnItem },
    vaultStore,
    activityStore,
    commonStore,
    userStore,
    userStore: { user },
    receivingdeliveryStore: {
      loadReceivingDelivery,
      selectedReceivingDelivery,
    },
    ElementStore: { generatePdf },
  } = useStore();
  const {
    vaultList,
    getRackList,
    rackList,
    getShelfList,
    shelfList,
    getPigeonList,
    pigeonList,
  } = vaultStore;
  const { selectedActivity } = activityStore;
  const [selectedShelfOption, setSelectedShelfOption] = useState<
    optionsInterface[]
  >([]);
  const [selected, setSelected] = useState<Activity | undefined>(
    selectedActivity,
  );
  const [vaultOptions, setVaultOptions] = useState<optionsInterface[]>([]);
  const [rackOptions, setRackOptions] = useState<optionsInterface[]>([]);
  const vaultId = useRef<string>('');
  // const [isAllowed, setIsAllowed] = useState<boolean>(true);
  const [tagPDFData, setTagPDFData] = useState<{
    Title: string;
    'Element Type': string;
    'Vault Location': string;
    'Physical Case Count': number;
    Description: string;
    Barcode: string;
  }>({
    Title: '',
    'Element Type': '',
    'Vault Location': '',
    'Physical Case Count': 0,
    Description: '',
    Barcode: '',
  });

  useEffect(() => {
    setSelected(selectedActivity);
    loadReceivingDelivery(selectedActivity?.registerId || '');
    // eslint-disable-next-line
  }, [selectedActivity]);

  useEffect(() => {
    if (selected) {
      let tempTagData = {
        ...tagPDFData,
        Title:
          selected.title?.split(' - ')?.[0] +
          ' ~ ' +
          selected.title?.split('~')?.[1],
        'Element Type': selected.type,
        'Vault Location': selected?.physical_location_vault?.split('/')?.[0],
        'Physical Case Count': selected.calculated_category,
        Barcode: selected.physical_sensor_barcode,
      };
      setTagPDFData(tempTagData);
    }
    // eslint-disable-next-line
  }, [selected, user]);

  useEffect(() => {
    if (selectedReceivingDelivery?.receiver_Description) {
      let tempTagData = {
        ...tagPDFData,
        Description: selectedReceivingDelivery.receiver_Description,
      };
      setTagPDFData(tempTagData);
    }
    // eslint-disable-next-line
  }, [selectedReceivingDelivery?.receiver_Description]);

  useEffect(() => {
    if (dashboard.getQrCodeValue !== '' && selected !== undefined) {
      const newArr = {
        ...selected,
        physical_sensor_qrcode: dashboard.getQrCodeValue,
        physical_sensor_barcode:
          dashboard.getBarCodeValue === selectedActivity?.id ||
          dashboard.getBarCodeValue === ''
            ? dashboard.getQrCodeValue
            : dashboard.getBarCodeValue,
        physical_sensor_RFID:
          dashboard.getRfidValue === selectedActivity?.id ||
          dashboard.getRfidValue === ''
            ? dashboard.getQrCodeValue
            : dashboard.getRfidValue,
      };
      setSelected(newArr);
    }
    // eslint-disable-next-line
  }, [
    dashboard.getQrCodeValue,
    dashboard.getBarCodeValue,
    dashboard.getRfidValue,
  ]);

  useEffect(() => {
    if (dashboard.getBarCodeValue !== '' && selected !== undefined) {
      const newArr = {
        ...selected,
        physical_sensor_barcode: dashboard.getBarCodeValue,
        physical_sensor_RFID:
          dashboard.getRfidValue === selectedActivity?.id ||
          dashboard.getRfidValue === ''
            ? dashboard.getBarCodeValue
            : dashboard.getRfidValue,
        physical_sensor_qrcode:
          dashboard.getQrCodeValue === selectedActivity?.id ||
          dashboard.getQrCodeValue === ''
            ? dashboard.getBarCodeValue
            : dashboard.getQrCodeValue,
      };
      setSelected(newArr);
    }
    // eslint-disable-next-line
  }, [
    dashboard.getBarCodeValue,
    dashboard.getRfidValue,
    dashboard.getQrCodeValue,
  ]);

  useEffect(() => {
    if (dashboard.getRfidValue !== '' && selected !== undefined) {
      const newArr = {
        ...selected,
        physical_sensor_RFID: dashboard.getRfidValue,
        physical_sensor_barcode:
          dashboard.getBarCodeValue === selectedActivity?.id ||
          dashboard.getBarCodeValue === ''
            ? dashboard.getRfidValue
            : dashboard.getBarCodeValue,
        physical_sensor_qrcode:
          dashboard.getQrCodeValue === selectedActivity?.id ||
          dashboard.getQrCodeValue === ''
            ? dashboard.getRfidValue
            : dashboard.getQrCodeValue,
      };
      setSelected(newArr);
    }
    // eslint-disable-next-line
  }, [
    dashboard.getRfidValue,
    dashboard.getBarCodeValue,
    dashboard.getQrCodeValue,
  ]);

  useEffect(() => {
    if (vaultList.length > 0) {
      const tempVaultOptions = vaultList.map((v) => {
        return {
          key: v.id,
          text: v.name,
          value: v.name + '/' + v.gpsLocation,
        };
      });
      setVaultOptions(tempVaultOptions);
    } else {
      setVaultOptions([]);
      setRackOptions([]);
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [vaultList]);

  useEffect(() => {
    if (rackList.length > 0) {
      const tempRack = rackList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setRackOptions(tempRack);
    } else {
      setRackOptions([]);
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [rackList]);

  useEffect(() => {
    if (shelfList.length > 0) {
      const tempShelf = shelfList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setSelectedShelfOption(tempShelf);
    } else {
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [shelfList]);

  // useEffect(() => {
  //   (async () => {
  //     if (
  //       commonStore.hfcCustomerChanges &&
  //       selected !== undefined &&
  //       selected?.physical_location_vault !== '' &&
  //       selected?.physical_location_shelf !== '' &&
  //       selected?.physical_location_rack !== ''
  //     ) {
  //       const payload = {
  //         customerName: user?.customerName || '',
  //         vaultName: selected?.physical_location_vault.split('/')[0],
  //         rackNo: selected?.physical_location_rack,
  //         shelfNo: selected?.physical_location_shelf,
  //       };
  //       const allowed = await agent.HFC.tagValidationHfc(payload);
  //       if (!allowed.data?.toLocaleLowerCase().includes('okay')) {
  //         toast.info(allowed.data);
  //         setIsAllowed(false);
  //       } else {
  //         setIsAllowed(true);
  //       }
  //     }
  //   })();
  //   // eslint-disable-next-line
  // }, [selected?.physical_location_shelf, commonStore.hfcCustomerChanges]);

  const conditionalEnable = () => {
    if (
      selected !== undefined &&
      selected?.physical_location_vault !== '' &&
      selected?.physical_location_shelf !== '' &&
      selected?.physical_location_rack !== '' &&
      selected?.assetCondition !== '' &&
      selected?.assetCondition !== undefined
      // && isAllowed
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    getPigeonList();
  }, [getPigeonList]);

  const handleOnChange = (e: any, data: any) => {
    if (selected !== undefined) {
      let newArr = {
        ...selected,
        movementdate: new Date().toISOString(),
        asset_tracking_status: 'Tagged',
        [data.name]: data.value,
      };

      if (data.name === 'physical_location_vault') {
        if (data.value !== '') {
          const { key } =
            data.value !== ''
              ? data?.options?.find(
                  (o: optionsInterface) => o.value === data.value,
                )
              : '';
          getRackList({ vaultId: key });
          vaultId.current = key;
        }
        newArr = {
          ...newArr,
          physical_location_rack: '',
          physical_location_shelf: '',
        };
      } else if (data.name === 'physical_location_rack') {
        if (data.value !== '') {
          getShelfList({ vaultId: vaultId.current, rackNo: data.value });
        }
        newArr = {
          ...newArr,
          physical_location_shelf: '',
        };
      }
      setSelected(newArr);
    }
  };

  const setPhysicalCaseCount = (e: any, data: any) => {
    if (selected !== undefined) {
      const newArr = {
        ...selected,
        [data.name]: data.value,
      };
      setSelected(newArr);
    }
  };

  const addToItemFiles = async (blobFile: Blob) => {
    await handleSubmit().then(async () => {
      let response;
      let addFilesPayload: uploadFileType = { id: '', files: [] };
      var file = new File([blobFile], 'TagVerify.pdf');
      if (commonStore.devEnv) {
        const item = selected?.id;
        const workLevel = dashboard.dashboardWorkLevelMaster?.id || 'Tag PDF';
        response = await agent.Files.localFileUpload(file, workLevel, item);
        const url = response.data.path.replace(/\\\\/g, '\\');
        const filename = url.substring(url.lastIndexOf('\\') + 1);
        addFilesPayload = {
          id: selected?.id,
          files: [
            {
              id: uuid(),
              fileId: response.data.id,
              fileName: filename,
              url: url,
              addedOn: new Date(),
            },
          ],
        };
        getLocalFilesBasedOnItem(item);
      } else {
        response = await agent.Files.uploadFile(file);
        addFilesPayload = {
          id: selected?.id,
          files: [{ ...response.data, addedOn: new Date() }],
        };
      }
      await generatePdf(addFilesPayload);
    });
  };

  const handleSubmit = async () => {
    if (selected !== undefined) {
      const TagData = {
        id: selected.id || '',
        asset_tracking_status: 'Tagging',
        physical_location_rack: selected.physical_location_rack,
        physical_location_vault: selected.physical_location_vault.split('/')[0],
        physical_location_shelf: selected.physical_location_shelf,
        global_positioning_system:
          selected.physical_location_vault.split('/')[1],
        physical_sensor_RFID: selected.physical_sensor_RFID || selected.id,
        physical_sensor_NFC: selected.physical_sensor_NFC || selected.id,
        physical_sensor_qrcode: selected.physical_sensor_qrcode || selected.id,
        physical_sensor_barcode:
          selected.physical_sensor_barcode || selected.id,
        assetCondition: selected.assetCondition,
        calculated_category: selected.calculated_category,
        synopsis: selected.synopsis,
      };
      await agent.Activities.physicalAsset(selected.id, TagData);
      if(user?.customerName === 'PCPLCRM' && user?.roleName === 'IT Team'){
        const response = await agent.Activities.details(selected?.id);
        const metadataMap: { [key: string]: string } = {
          Building: selected.physical_location_vault.split('/')[0],
          Floor: selected.physical_location_rack,
          'Rack no': selected.physical_location_shelf,
          'New Asset Tag': selected.physical_sensor_barcode || selected.id,
          'Location':selected.physical_location_vault.split('/')[1]
        };
        response.data.metadata.forEach((item) => {
        if (metadataMap[item.elementName]) {
          item.elementValue = metadataMap[item.elementName];
        }
      });
      await agent.mediaAsset.putMetaData(response.data);
      }
      toast.success('Item Tagged Sucessfully');
      activityStore.activityRegistryAll.delete(selected.id);
      tagCount();
      sendRespectiveEmail(
        'Notification',
        selected.title,
        'Tagged Record',
        '',
        `${selected.type} is tagged successfully on`,
      );
      dashboard.onFirstLoadNoTransition = false;
      dashboard.setfadeIn = false;
      dashboard.assetTableClickedValueTag = '';
      commonStore.updateHistoryAlonePOST(
        `${selected.title} was Tagged by ${userStore.user?.displayName || ''}`,
        activityStore.selectedActivity?.id,
        undefined,
        true,
        true,
      );
      if (commonStore.filterModeOne.includes('IRB4')) {
        dashboard.valueForL3Inventory = 'Create Order Receiving';
      }
      setTimeout(() => {
        dashboard.setfadeIn = true;
      }, 1000);
      // showClickedValueForAssetTable('');
      activityStore.loadTagPagination(dashboard.setTagTablePageNumber);
      setSelected(undefined);
    }
  };

  const childpanes = [
    {
      menuItem: selected?.element,
      render: () => (
        <Tab.Pane>
          {selected?.id !== undefined ? (
            <CaptureButtons
              physical_sensor_RFID={
                selected.physical_sensor_RFID !== undefined
                  ? selected.physical_sensor_RFID
                  : selected.id
              }
              physical_sensor_qrcode={
                selected.physical_sensor_qrcode !== undefined
                  ? selected.physical_sensor_qrcode
                  : selected.id
              }
              physical_sensor_barcode={
                selected.physical_sensor_barcode !== undefined
                  ? selected.physical_sensor_barcode
                  : selected.id
              }
            />
          ) : null}

          <Form>
            <Form.Field
              style={{ width: '40vw' }}
              clearable
              fluid
              search
              selection
              options={vaultOptions}
              control={Select}
              placeholder={
                user?.customerName === 'LVP CMS - AM'
                  ? 'Select Room'
                  : (
                      userLanguage[0].Level3InventoryRecievingTagTab
                        ?.IRVTTDD01 as any
                    )?.[`${commonStore.language.key}`]
              } //Select vault
              label={
                user?.customerName === 'LVP CMS - AM'
                  ? 'Room'
                  : (
                      userLanguage[0].Level3InventoryRecievingTag?.IRTL02 as any
                    )?.[`${commonStore.language.key}`]
              } //"Vault"
              name="physical_location_vault"
              onChange={handleOnChange}
              value={selected?.physical_location_vault}
            />
            <Form.Field
              style={{ width: '40vw' }}
              clearable
              fluid
              search
              selection
              options={rackOptions}
              name="physical_location_rack"
              placeholder={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD02 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              label={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD02 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              control={Select}
              onChange={handleOnChange}
              value={selected?.physical_location_rack}
            />
            <Form.Field
              style={{ width: '40vw' }}
              clearable
              fluid
              search
              selection
              options={selectedShelfOption}
              name="physical_location_shelf"
              placeholder={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD03 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              label={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD03 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              control={Select}
              onChange={handleOnChange}
              value={selected?.physical_location_shelf}
            />
            <Form.Field
              style={{ width: '40vw' }}
              clearable
              fluid
              search
              selection
              upward
              options={assetConditionOptions}
              name="assetCondition"
               label={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD04 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              control={Select}
              placeholder={
                (userLanguage[0].Level3InventoryRecievingTagTab.IRVTTD05 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              onChange={handleOnChange}
              value={selected?.assetCondition!}
            />
            {commonStore.hfcCustomerChanges && (
              <>
                <Form.Field>
                  <label>Physical Case Count</label>
                  <Input
                    style={{ width: '40vw' }}
                    name="calculated_category"
                    type="number"
                    placeholder={'Enter Physical Case Count'}
                    onChange={setPhysicalCaseCount}
                    value={selected?.calculated_category!}
                  />
                </Form.Field>
                <Form.Field
                  style={{ width: '40vw' }}
                  clearable
                  fluid
                  search
                  selection
                  upward
                  options={pigeonList}
                  name="synopsis"
                  label={'Pigeon Hole'}
                  control={Select}
                  placeholder={'Pigeon Hole'}
                  onChange={handleOnChange}
                  value={selected?.synopsis!}
                />
              </>
            )}
          </Form>
        </Tab.Pane>
      ),
    },
  ];

  const parentpanes = [
    {
      menuItem: selected?.title + '-' + selected?.type,
      render: () => (
        <Tab.Pane>
          <Tab panes={childpanes} />
        </Tab.Pane>
      ),
    },
  ];
  if (activityStore.loadingInitial) return <LoadingComponent />;
  return (
    <div>
      {dashboard.openQrCodeScanner ? (
        <QrCodeScannerModal
          activityid={selected?.id}
          qrcodeValue={selected?.physical_sensor_qrcode}
        />
      ) : null}
      {dashboard.openBarCodeScanner ? (
        <BarCodeScannerModal
          activityid={selected?.id}
          barcodeValue={selected?.physical_sensor_barcode}
        />
      ) : null}
      {dashboard.openRfidScanner ? (
        <RfidScannerModal
          activityid={selected?.id}
          rfidValue={selected?.physical_sensor_RFID}
        />
      ) : null}
      {/* -------------------------------Component Starts Here */}
      {dashboard.assetTableClickedValueTag === '' && selected === undefined ? (
        <p
          style={{ marginTop: '10px' }}
          //Please select item received
        >
          {
            (userLanguage[0].Level3InventoryRecievingTagTab?.IRVTTL01 as any)?.[
              `${commonStore.language.key}`
            ]
          }
        </p>
      ) : (
        <div className="tag-tabpane-height" style={{ position: 'relative' }}>
          <Tab panes={parentpanes} />
          <div style={{ marginTop: '14px' }}>
            <Button.Group>
              <Button>
                {
                  (
                    userLanguage[0].Level3InventoryRecievingTag?.IRTB06 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
              <Button.Or
                text={
                  (
                    userLanguage[0].Level3InventoryRecievingTag?.IRTB07 as any
                  )?.[`${commonStore.language.key}`]
                }
              />
              {commonStore.hfcCustomerChanges ? (
                <div
                  className={conditionalEnable() ? '' : 'component-isDisabled'}
                >
                  <PDFDownloadLink
                    document={<TagVerifyPDF tagDetails={tagPDFData} />}
                    // document={<></>}
                    fileName="TagVerify.pdf"
                    className="genRep"
                  >
                    {({ blob, url, loading, error }) => (
                      <Button
                        onClick={() => addToItemFiles(blob!)}
                        color="blue"
                        style={{
                          borderTopLeftRadius: '0px',
                          borderBottomLeftRadius: '0px',
                        }}
                      >
                        {
                          (
                            userLanguage[0].Level3InventoryRecievingTag
                              ?.IRTB08 as any
                          )?.[`${commonStore.language.key}`]
                        }
                      </Button>
                    )}
                  </PDFDownloadLink>
                </div>
              ) : (
                <Button
                  positive
                  onClick={handleSubmit}
                  disabled={
                    !(
                      selected?.physical_location_vault &&
                      selected?.physical_location_shelf &&
                      selected?.physical_location_rack
                    )
                  }
                  //Save
                >
                  {
                    (
                      userLanguage[0].Level3InventoryRecievingTag?.IRTB08 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </Button>
              )}
            </Button.Group>
          </div>
        </div>
      )}
    </div>
  );
}

export default observer(DashboardOnClickedTag);
